import { Axios } from './Axios';

export function inviteToOrJoinClass(inviteObj) {
  const url = `join-request?populate=requesterUserId classId`;
  return Axios({
    url,
    method: 'post',
    data: inviteObj
  });
}

export function getAllPendingRequest(orgId) {
  const url = `join-request?orgId=${orgId}&requesterStatus=pending&populate=requesterUserId classId`;
  return Axios({
    url,
    method: 'get'
  });
}

export function updateInviteRequest(id, obj) {
  const url = `join-request?requestId=${id}`;
  return Axios({
    url,
    method: 'patch',
    data: obj
  });
}
